import api from './api';

/** Metadatos del catálogo corporativo vigente (admin). */
export interface LeadCatalogMeta {
  url: string;
  filename: string | null;
  updatedAt: string | null;
}

/** Resultado de capturar un lead: su id y, si aplica, la URL del catálogo. */
export interface CreatedLead {
  id: string;
  catalogUrl?: string;
}

export interface Lead {
  id: string;
  email: string;
  source: string;
  createdAt: string;
}

export interface LeadPage {
  leads: Lead[];
  pagination: { page: number; limit: number; total: number; pages: number };
}

class LeadService {
  /** Captura un lead (catálogo o newsletter). */
  async createLead(input: {
    email: string;
    source: 'catalogo' | 'newsletter';
  }): Promise<CreatedLead> {
    const response = await api.post('/leads', input);
    return {
      id: response.data.lead.id,
      catalogUrl: response.data.catalogUrl,
    };
  }

  /** Listado paginado de leads capturados (admin). */
  async getLeads(
    params: { page?: number; limit?: number } = {}
  ): Promise<LeadPage> {
    const response = await api.get('/admin/leads', { params });
    return {
      leads: response.data.leads,
      pagination: response.data.pagination,
    };
  }

  /** ¿Hay catálogo disponible? (público, sin exponer la URL). */
  async getCatalogStatus(): Promise<{ available: boolean }> {
    const response = await api.get('/site-content/catalog');
    return response.data.data;
  }

  /** Metadatos del catálogo vigente (admin). */
  async getCatalogMeta(): Promise<LeadCatalogMeta | null> {
    const response = await api.get('/admin/catalog');
    return response.data.catalog;
  }

  /** Sube/reemplaza el PDF del catálogo (admin). */
  async uploadCatalog(file: File): Promise<LeadCatalogMeta> {
    const form = new FormData();
    form.append('catalog', file);
    const response = await api.post('/admin/catalog', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.catalog;
  }
}

export default new LeadService();
